var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.currentUser && _setup.historyName)?_c(_setup.InvocationsList,{attrs:{"user-id":_setup.currentUser.id,"history-id":_vm.historyId,"history-name":_setup.historyName}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }